import script from "./navigation-item.vue?vue&type=script&lang=ts&setup=true"
export * from "./navigation-item.vue?vue&type=script&lang=ts&setup=true"

import "./navigation-item.vue?vue&type=style&index=0&id=31c42dd1&lang=scss&scoped=true"

import exportComponent from "/builds/snedson/snotra-backend/snotra-front-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31c42dd1"]])

export default __exports__